import React from 'react'

const Orders = React.lazy(() => import('pages/Orders/pages/OrdersPage'));
const OrdersAdd = React.lazy(() => import('pages/Orders/pages/OrdersAdd'));
const OrdersEdit = React.lazy(() => import('pages/Orders/pages/OrdersEdit'));
const OrdersDetail = React.lazy(() => import('pages/Orders/pages/OrdersDetail'));

const OrdersRoutes = [
    {
        path: '/orders',
        exact: true,
        name: 'Danh sách đơn hàng',
        function: 'SL_ORDERS_VIEW',
        component: Orders,
    },
    {
        path: '/orders/add',
        exact: true,
        name: 'Thêm mới đơn hàng',
        function: 'SL_ORDERS_ADD',
        component: OrdersAdd,
    },
    {
        path: '/orders/edit/:id',
        exact: true,
        name: 'Chỉnh sửa đơn hàng',
        function: 'SL_ORDERS_EDIT',
        component: OrdersEdit,
    },
    {
        path: '/orders/detail/:id',
        exact: true,
        name: 'Chi tiết đơn hàng',
        function: 'SL_ORDERS_EDIT',
        component: OrdersDetail,
    },
]

export default OrdersRoutes
